import React, { useEffect, useState } from 'react';
import { TextProps, Switch, Text } from '@perch-labs/shrike';
import { RowChild } from 'styles';
import { TextWrapper, RowWrapper } from './switch-row.styles';

export type Tag = Pick<TextProps, 'tag'>['tag'];

interface Props {
  header?: string;
  subHeader?: string;
  toggle?: boolean;
  hasBottomBorder?: boolean;
  hideTopBorder?: boolean;
  onChange?: (checked: boolean) => void;
}

export const SwitchRow = (props: Props) => {
  const {
    header,
    subHeader,
    toggle,
    hasBottomBorder,
    hideTopBorder,
    onChange,
  } = props;

  const [checked, setChecked] = useState(toggle || false);

  const clickRow = () => {
    setChecked(!checked);
  };

  useEffect(() => {
    if (toggle !== checked && onChange) onChange(checked);
  }, [checked]);

  return (
    <RowWrapper
      hideTopBorder={hideTopBorder}
      hasBottomBorder={hasBottomBorder}
      onClick={clickRow}
    >
      <RowChild justifyContent="flex-start">
        <TextWrapper data-testid="switch">
          <Switch checked={checked} label="" onChange={clickRow} width="50px" />
        </TextWrapper>
        <div>
          <Text
            margin={{ left: '20px' }}
            tag="p"
            textStyle="paragraph500"
            color="primary"
            opacity="high"
          >
            {header}
          </Text>
          <Text
            margin={{ left: '20px', top: '10px' }}
            color="primary"
            opacity="low"
            textStyle="paragraph400"
          >
            {subHeader}
          </Text>
        </div>
      </RowChild>
    </RowWrapper>
  );
};
